/*================================================================================================================
      PROFILE CONTROLLER
      ================================================================================================================*/
angular
    .module('vppApp')
    .controller('ProfileController', ProfileController);

ProfileController.$inject = ['$scope', 'AuthenticationService', 'apiFactory', '$log', '$state', '$rootScope', 'vppConfig', 'ProfileSecurityService', 'UpdateAccountService', 'ModuleService', '$compile', 'TimeOutService', 'CustomerService'];


function ProfileController($scope, AuthenticationService, apiFactory, $log, $state, $rootScope, vppConfig, ProfileSecurityService, UpdateAccountService, ModuleService, $compile, TimeOutService, CustomerService) {

    var accountId = AuthenticationService.getAuthenticatedID();
    var _updateAccountFor = vppConfig.folderPath;
    var brandBarTitles = {
        emp: "Family First Information Update",
        ded: "Dealer Information Update",
        gmed: "School Information Update",
        sup: "Supplier Information Update",
        mpp: "Military Service Information Update",
        cgp: "College Information Update",
        frd: "First Responder Information Update"
    };

    $scope.brandBarTitle = brandBarTitles[_updateAccountFor];
    $scope.siteName = vppConfig.siteNames[vppConfig.folderPath];

    $scope.modService = ModuleService;
    $scope.partnerName = '';
    $scope.subsidiaryId;
    $scope.subsidiaries;
    $scope.subsidiaryName = '';
    $scope.isEMP = ((vppConfig.folderPath === "emp") ? true : false);
    $scope.isFRD = ((vppConfig.folderPath === "frd") ? true : false);
    $scope.isMPP = ((vppConfig.folderPath === "mpp") ? true : false);
    $scope.isCGP = ((vppConfig.folderPath === "cgp") ? true : false);
    $scope.isDED = ((vppConfig.folderPath === "ded") ? true : false);
    $scope.isGMED = ((vppConfig.folderPath === "gmed") ? true : false);
    $scope.isSUP = ((vppConfig.folderPath === "sup") ? true : false);
    $scope.OnStarLock = ((vppConfig.folderPath !== 'mpp' && vppConfig.folderPath !=='ded' ));
    $scope.verifyUserPassword = '';
    $scope.subsidiary = {
        selectedSubsidiary: null
    };

    $scope.accountInfo = {
        "accountDetails": {
            "firstName": "",
            "lastName": "",
            "streetAddress": "",
            "city": "",
            "stateInclPR": "",
            "postalCode": "",
            "phoneNumber": "",
            "emailAddress": "",
            "cellPhone": ""
        }
    };

    $scope.loginDetails = {
        "password": "",
        "securityQuestion": "",
        "securityAnswer": ""
    };

    // get profile details:
    apiFactory.getProfileDetails(accountId).then(function (response) {
        $scope.accountInfo.accountDetails = response.data.customerDetails;
        if ($scope.isEMP) {
            $scope.accountInfo.accountDetails.stateInclPR = $scope.accountInfo.accountDetails.state;
        }
        $scope.accountInfo.accountDetails.emailAddress = $scope.accountInfo.accountDetails.emailAddress.toLowerCase();
        $scope.accountInfo.accountDetails.confirmEmail = $scope.accountInfo.accountDetails.emailAddress;
        ModuleService.setModuleDetails(response.data, _updateAccountFor);
        processDropDowns();

        if(vppConfig.folderPath !== 'mpp' && vppConfig.folderPath !=='ded') {
            apiFactory.getOnStarLockStatus($scope.accountInfo.accountDetails.emailAddress).then(function (response) {
                $scope.OnStarLock = response.data.locked;
            });
        }

    }, function errorCallback(response) {
        // $log.info(response.data.errors);
        $scope.serverError = response.data.errors;
        $scope.profileDetailsError = true;
        TimeOutService.checkAuthError(response);
        // called asynchronously if an error occurs
        // or server returns response with an error status.
        // console.log('errorCode: ' + $scope.serverError);
    });

    // Set Drop Downs for
    function processDropDowns() {
        if (_updateAccountFor === "mpp" || _updateAccountFor === "gmed" || _updateAccountFor === "cgp") {
            switch (_updateAccountFor) {
                case "mpp":
                    var _tempStep3Obj = ModuleService.getModuleDetailsMPPServiceBranch();
                    $scope.serviceBranch = ModuleService.getModuleDetailsMPPServiceBranch();
                    $scope.mppStatus = ModuleService.getModuleDetailsMPPStatus();
                    // console.log("create DD for MPP");
                    // console.log($scope.serviceBranch);
                    break;
                case "gmed":
                    $scope.gmedPosition = ModuleService.getModuleDetailsGMEDPosition();
                    $scope.gmedSchoolType = ModuleService.getModuleDetailsGMEDSchoolType();
                    break;
                case "cgp":
                    $scope.cgpStates = ModuleService.getModuleDetailsCGPStates();
                    $scope.cgpCollegeLevel = ModuleService.getModuleDetailsCGPCollegeLevel();
                    break;
                default:
            }
            // set up dropdown data
        }
    }

    // get security questions:
    /*
    No need for security questions anymore
    apiFactory.getSecurityQuestions().then(function (response) {
        $scope.securityQuestionOptions = [];
        for (var question in response.data.data) {
            $scope.securityQuestionOptions[question] = response.data.data[question];
        }
        $scope.loginDetails.securityQuestion = $scope.securityQuestionOptions[0].key;
    }, function errorCallback(response) {
        // $log.info(response.data.errors);
        $scope.serverError = response.data.errors;
        $scope.securityQuestionError = true;
        TimeOutService.checkAuthError(response);
        // called asynchronously if an error occurs
        // or server returns response with an error status.
        console.log('errorCode: ' + $scope.serverError);
    });
    */

    switch (_updateAccountFor) {
        case "mpp":
            var _tempStep3Obj = ModuleService.getModuleDetailsMPPServiceBranch();
            $scope.serviceBranch = ModuleService.getModuleDetailsMPPServiceBranch();
            $scope.mppStatus = ModuleService.getModuleDetailsMPPStatus();
            break;
        case "gmed":
            $scope.gmedPosition = ModuleService.getModuleDetailsGMEDPosition();
            $scope.gmedSchoolType = ModuleService.getModuleDetailsGMEDSchoolType();
            break;
        case "cgp":
            $scope.cgpStates = ModuleService.getModuleDetailsCGPStates();
            $scope.cgpCollegeLevel = ModuleService.getModuleDetailsCGPCollegeLevel();
            break;
        default:
    }

    $scope.getMiddleSection = function () {
        var _tempString = "/content/html/partials/forms/" + _updateAccountFor + "/update-profile-" + _updateAccountFor + "-information.html";
        return _tempString;
    };

    $scope.saveChangeUsername = function () {
        apiFactory.changeUsernameRequest(accountId, $scope.accountInfo).then(function (response) {
            // console.log(response)
            if (response.data.status === 'success'){
                $scope.usernameChange = true
            }
            else{
                $scope.usernameChange = false
                $scope.hideModal();
            }

        }, function errorCallback(response) {
            // $log.info(response.data.errors);
            $scope.usernameChange = false
            $scope.serverError = response.data.errors;
            $scope.profileDetailsError = true;
            TimeOutService.checkAuthError(response);
            $scope.hideModal();
            $scope.loginDetails.password = "";
            ProfileController($scope, AuthenticationService, apiFactory, $log, $state, $rootScope, vppConfig, ProfileSecurityService, UpdateAccountService, ModuleService);

            // called asynchronously if an error occurs
            // or server returns response with an error status.
            //console.log('errorCode: ' + $scope.serverError);
        });
    };

    $scope.saveAccountInformation = function () {

        apiFactory.setProfileDetails(accountId, $scope.accountInfo).then(function (response) {

            //console.log('=================== Profile Details Updated ===================');
            apiFactory.getCustomer(accountId)
                .then(function successGetCustomer(response) {
                    CustomerService.setCustomer(response);
                    $state.go('view-auth');
                    $scope.hideModal();
                }, function errorCallback(response) {
                    $scope.serverError = response.data.errors;
                    $scope.hideModal();
                });

        }, function errorCallback(response) {
            // $log.info(response.data.errors);
            $scope.serverError = response.data.errors;
            $scope.profileDetailsError = true;
            TimeOutService.checkAuthError(response);
            $scope.hideModal();
            $scope.loginDetails.password = "";
            ProfileController($scope, AuthenticationService, apiFactory, $log, $state, $rootScope, vppConfig, ProfileSecurityService, UpdateAccountService, ModuleService);

            // called asynchronously if an error occurs
            // or server returns response with an error status.
            //console.log('errorCode: ' + $scope.serverError);
        });
    };

    $scope.saveLoginDetails = function () {
        $scope.changePasswordError = false;
        var body = {
            'username': $scope.accountInfo.accountDetails.emailAddress,
            'newPassword': $scope.loginDetails.password,
            'password': $scope.loginDetails.currentPassword,
            'sendEmail': 'true'
        };
        apiFactory.changePassword(body).then(function (response) {
            if (response.data.status === 'failure') {
                $scope.changePasswordError = true;
                $scope.loginDetailsError = true;
                TimeOutService.checkAuthError(response);
            } else if (response.data.status === 'success') {
                $state.go('view-auth');
            }
        }, function errorCallback(response) {
            $scope.serverError = response.data.errors;
            $scope.loginDetailsError = true;
            TimeOutService.checkAuthError(response);
        });
    };

    $scope.saveSpecificSiteInformation = function (moduleDetails) {
        // for SUP & DED only
        if (_updateAccountFor === "sup" || _updateAccountFor === "ded") {
            var subsidiaryName;


            //used to be partnerClientCode
            moduleDetails.moduleDetails.partnerClientCode.partnerId = $scope.modService.partnerID;
            if ($scope.modService.subsidiaries) {
                moduleDetails.moduleDetails.partnerClientCode.partnerId = $scope.modService.partnerID;
                subsidiaryName = $scope.subsidiary.selectedSubsidiary;

            } else {
                subsidiaryName = $scope.modService.partnerName
            }
            moduleDetails.moduleDetails.partnerClientCode.subsidiaryName = subsidiaryName;
        }

        UpdateAccountService.setModuleDetails(moduleDetails);
        var _registrationObj = UpdateAccountService.buildRegistrationObj(_updateAccountFor);
        // console.log(_registrationObj);

        apiFactory.setModifiedProfileDetails(accountId, _registrationObj)
            .then(function successRegistration(response) {
                $scope.modService.clearSiteModule();
                $state.go("view-auth");
            }, function errorCallback(response) {
                //console.log(response.data.errors);
                $scope.serverError = response.data.errors;
                $scope.specificSiteInformationError = true;
                TimeOutService.checkAuthError(response);

            });
    };

    // SUP & MPP - Reads User input and populates non-editable input and populates select box if it has subsidiaries.
    $scope.fetchdata = function () {
        $scope.modService = ModuleService;
        ModuleService.processPartnerAndSubsidiaryForCode($scope);
        // watch for Errors from API
        $scope.$watch('modService.serverError', function (hasServerError) {
            $scope.serverError = hasServerError;
        });
    };

    // CGP - gets selected State and populates next select box.
    $scope.fetchPartnerList = function () {
        $scope.modService = ModuleService;
        ModuleService.processPartnerListForState($scope);
        // watch for Errors from API
        $scope.$watch('modService.serverError', function (hasServerError) {
            $scope.serverError = hasServerError;
        });
    };

    $scope.hideModal = function () {
        $scope.show = false;
        if($scope.$parent.$parent.hasOwnProperty('modalShown')){
          $scope.$parent.$parent.modalShown = false;
        } else if($scope.$parent.$parent.$parent.hasOwnProperty('modalShown')){
          $scope.$parent.$parent.$parent.modalShown = false;
        } else if($scope.$parent.$parent.$parent.$parent.hasOwnProperty('modalShown')){
          $scope.$parent.$parent.$parent.$parent.modalShown = false;
        } else if($scope.$parent.$parent.$parent.$parent.$parent.hasOwnProperty('modalShown')){
          $scope.$parent.$parent.$parent.$parent.$parent.modalShown = false;
        }

        document.getElementsByTagName('body')[0].style['overflow'] = "auto";
    };

    $scope.cancelEmailChange = function (targetForm) {
        targetForm.$setUntouched();

        $scope.hideModal();
    };

    $scope.cancelUpdate = function (targetForm) {

        $scope.loginDetails.password = "";
        targetForm.verifyUserPassword = "";
        $scope.loginDetails.securityQuestion = "";
        $scope.loginDetails.securityAnswer = "";

        targetForm.$setUntouched();

        // I call this to reset the profile fields:
        ProfileController($scope, AuthenticationService, apiFactory, $log, $state, $rootScope, vppConfig, ProfileSecurityService, UpdateAccountService, ModuleService);

        $scope.accordionAccount.collapseAll();
        $scope.accordionSpecific.collapseAll();
        $scope.accordionLogin.collapseAll();

    };
};
